import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface DesignDeleteAllConfirmationDialogProps {
  setShow: (show: boolean) => void;
  show: boolean;
  handleDeleteAll: () => void;
}
export function DesignDeleteAllConfirmationDialog({
  setShow,
  show,
  handleDeleteAll,
}: DesignDeleteAllConfirmationDialogProps) {
  if (!show) return null;
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-background/75 backdrop-blur-[1px]">
      <div className="w-full max-w-md rounded-lg border bg-background p-6 shadow-lg">
        <div className="mb-4">
          <p className="text-xl font-semibold"> Delete Structures? </p>
          <p className="mt-2 text-sm text-muted-foreground">
            Are you sure you want to remove all listed structures?
          </p>
          <p className="mt-2 text-sm text-destructive">
            This action will delete all listed structures and their related data permanently if they
            are only used on this mask
          </p>
        </div>
        <div className="flex justify-between gap-2">
          <Button variant="outline" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDeleteAll}>
            <Trash2 className="mr-2 h-4 w-4" /> Delete Structure
          </Button>
        </div>
      </div>
    </div>
  );
}
